import * as React from "react";
import { hashHistory } from "react-router";
import { inject, observer } from "mobx-react";
import SeekerStore from "../../stores/seekerStore";
import { Grid, Row, Col } from "react-flexbox-grid";
import { sort } from "../../utils/data";
import FeaturedContent from "../../models/featuredContent";
import { FeatureLevel } from "../../models/enums";
import * as s from "./gettingStarted.css";
import { Auth } from "../../utils/auth";

@inject("store") @observer
export default class GettingStartedVw extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  componentWillMount(): void {
    if (Auth.isAuthenticated) {
      this.props.store.viewState.trackView();
    }
  }
 renderContent(content: Array<FeaturedContent>): JSX.Element[] {
    const items: JSX.Element[] = [];
    sort(content, "order").map((fc: FeaturedContent, i: number): void => {
      const imgUrl: string = `/image/${fc.imageId}`;
      const internalLink: string = fc.link;
      items.push(<Col key={"getting-started-" + fc.imageId} xs={12} className={s.col}><a href={internalLink} ><img src={imgUrl} /></a></Col>); 
    });
    return items;
  } 

 render(): JSX.Element {
   const detailItems: Array<FeaturedContent> = this.props.store.viewState.featuredContent.filter((fc: FeaturedContent): boolean => { return fc.level === FeatureLevel.Detail });
   return (<Row className={s.row}>
     {this.renderContent(detailItems)}
    </Row>);
  }
}


// WEBPACK FOOTER //
// ./src/views/gettingStarted/index.tsx